import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { DonError } from '../errors/don-error';

/**
 * Normalises every failed response into a `DonError` so components branch on
 * status instead of re-parsing bodies.
 *
 * It deliberately renders nothing. Features already toast in their own catch
 * blocks, and a global toast here would fire a second time on top of those.
 * Anything that is not an `HttpErrorResponse` is rethrown untouched.
 */
export const problemDetailInterceptor: HttpInterceptorFn = (request, next) =>
  next(request).pipe(
    catchError((error: unknown) =>
      throwError(() => (error instanceof HttpErrorResponse ? DonError.fromHttpError(error) : error))
    )
  );
